import { Title, DataTableV2 } from "components/commons";
import locale from "localization/en";
import styles from "../dry-stock.module.scss";
import useDataTable from "hooks/useDataTable";
import { FormMode } from "enums";
import { dryStockMovementMapper } from "./dry-stock-movement.mapper";
import { dryStockMovementColumn } from "./dry-stock-movement-column";

const DryStockMovement = ({ shift, form, pageMode, inventory, setInventory, allProducts }) => {
  const isEdit = pageMode === FormMode.Edit;
  const products = new Map(allProducts.map((p) => [p.productId, p]));
  const isBeginningEnabled =
    shift.recentShift !== null ? shift.recentShift.inventoryCount === 0 : true;

  const computedQuantity = shift.delivery.deliveryProducts.reduce((acc, dp) => {
    const sku = dp.product;
    const quantity = dp.quantityDelivered || 0;
    acc[sku] = (acc[sku] || 0) + quantity;
    return acc;
  }, {});

  const formattedList = shift.shift.inventories
    .map((inventory) => {
      const product = products.get(inventory.productId);
      const sku = product?.sku;
      const totalQuantityDelivered = sku ? computedQuantity[sku] || 0 : 0;

      return {
        ...inventory,
        sku: sku || "-",
        product: product?.name || "-",
        variant: product?.variant || "-",
        type: product?.type || "-",
        totalQuantityDelivered,
        isBeginningEnabled,
      };
    })
    .sort((a, b) => a.product.localeCompare(b.product));

  const dryStockMovementTable = useDataTable({
    value: formattedList,
    filter: { initialState: {}, mapper: (val) => val },
    table: {
      key: "inventories",
      name: "dryStockMovements",
      mapper: (val) => dryStockMovementMapper({ val, form, isEdit, inventory, setInventory }),
      columns: dryStockMovementColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.dryStockMovement}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2
          {...dryStockMovementTable.table}
          hideNoSearchResultRender
          tableVersion="v2"
          hidePagination
        />
      </div>
    </>
  );
};

export default DryStockMovement;
